<div class="message-modal">
    <img src="/assets/images/illustration-archived.svg" alt="" aria-hidden="true" class="header-image">
    <h1 class="title" id="modal-title" i18n="@@archivedProfile.title">Profil archiviert</h1>
    <p class="body" i18n="@@archivedProfile.body">
        <b>Dein Profil ist derzeit archiviert</b> und der Zugang zur Plattform ist eingeschränkt.
        Wenn du dein Profil wieder aktivieren möchtest, <b>kontaktiere uns</b> — wir helfen dir gerne weiter.
    </p>
    <p class="contact-email">
        <a href="mailto:feedback@clea.app">feedback@clea.app</a>
    </p>
    <div class="action">
        <button (click)="close()" class="button" i18n="@@archivedProfile.btn.close">Schliessen</button>
        <a href="mailto:feedback@clea.app" (click)="close()" class="button primary" i18n="@@archivedProfile.btn.contact">Kontakt aufnehmen</a>
    </div>
</div>
